<!--
 * @FilePath: AgentSelfTree.vue
 * @Author: Aron
 * @Date: 2023-08-03 11:05:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-16 11:07:30
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
-->
<template>
  <div style="display: inline-block; width: 100%">
    <!-- 替换展示框和搜索框的策略 -->
    <el-input class="selectClass" :placeholder="inputPlaceholder || $t('app.pleaseSelectUser')" v-model="lstUserName" v-popover:choseAgentPopover
      v-if="lstUserName && lstUserName != ''" readonly>
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">
          <i @click.stop="clearSelect" class="el-icon-circle-close"
            style="position: absolute;left: -16px;top: 14px;background-color: #ffffff;width: 20px;"></i>
          <i class="el-select__caret el-input__icon el-icon-arrow-up" :class="{
            'is-reverse': showAgentDropDown
          }"></i>
        </span>
      </span>
    </el-input>
    <el-input class="selectClass" :placeholder="inputPlaceholder || $t('app.pleaseSelectUser')" v-model="filterText" v-popover:choseAgentPopover v-else>
      <span class="el-input__suffix" slot="suffix">
        <span class="el-input__suffix-inner">

          <i
            class="el-select__caret el-input__icon el-icon-arrow-down"
            :class="{
              'is-reverse': showAgentDropDown
            }"
          ></i>
        </span>
      </span>
    </el-input>

    <el-popover popper-class="agent-popover" placement="bottom-start" height="300" ref="choseAgentPopover" trigger="click"
      @show="showAgentDepartmentPopover" @hide="hideAgentDepartmentPopover" :visible-arrow="false">
      <div style="max-height:300px;overflow: auto;">
        <div class="scrollbar-wrapper">
          <!-- <el-input class="keyword-search" :placeholder="searchPlaceholder">
        </el-input> -->
        <vueEasyTree
          :data="dataList"
          show-checkbox
          :check-strictly="isRadioType?true:false"
          :class="isRadioType?'radio-tree':''"
          @check-change="handleCheckChange"
          node-key="value"
          height="200px"
          ref="subAgentTree"
          :default-checked-keys="defaultCheckedKeys"
          :filter-node-method="filterNode"
        >
        </vueEasyTree>
      </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { getDeptTreeInfo } from "@/api/basicApi";
import { CRM_CAMPUS_TREE } from "@/util/keys";
import vueEasyTree from "@wchbrad/vue-easy-tree"
import "@wchbrad/vue-easy-tree/src/assets/index.scss"
export default {
  data() {
    return {
      filterAgentTextClass: "",
      agentTreeData: [],
      showAgentDropDown: false,
      lstUserName: this.defaultValue ? this.defaultValue : "",
      lstUserId: [],
      radios: [],
      dataList: [],
      defaultCheckedKeys: [],
      filterText: ""
    };
  },
  props: {
    isShowLabel: {
      type: Boolean,
      default: false
    },
    inputPlaceholder: {
      type: String,
      default: ""
    },
    isSingleChoice: {
      type: Boolean,
      default: false
    },
    doClear: {
      type: Boolean,
      default: false
    },
    isRadioType: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: ""
    }
  },
  components:{
		vueEasyTree,
	},
  watch: {
    filterText(val) {
      this.$refs.subAgentTree.filter(val);
    },
    doClear(newVal, oldVal) {
      this.clearSelect();
    },
    defaultValue(newVal, oldVal) {
      this.defaultValue = newVal
    },
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked, indeterminate) {
      if (checked) {
        this.$refs.subAgentTree.setCheckedKeys([data.value]);
        this.$emit('change-tree', data);
      }
    },
    breakUpCode(val) {
      return val.split("_")[1];
    },
    traverse(val) {
      for (let item of val) {
        item.label = `${this.breakUpCode(item.value)}-${item.title}`;
        item.id = Number(this.breakUpCode(item.value));
        if (item.children) {
          this.traverse(item.children);
        }
      }
    },
    async initData() {
      let campusTree = JSON.parse(
        sessionStorage.getItem(CRM_CAMPUS_TREE) || "[]"
      );
      if (campusTree <= 0) {
        campusTree = await getDeptTreeInfo();
        campusTree = campusTree.code === 0 ? campusTree.data : [];
        sessionStorage.setItem(CRM_CAMPUS_TREE, JSON.stringify(campusTree));
      }
      //构建结构
      // campusTree.push({
      //   children: null,key: "107416",titleKey: 'common.重2庆市沙坪坝区沙坪坝10',value: "107161_818"})
      this.traverse(campusTree);
      // 如果没有内容就不显示全选
      if (campusTree && campusTree.length > 0) {
        this.dataList = [
          {
            id: 0,
            label: this.$t('app.selectAll'),
			value:"0_0",
            children: campusTree
          }
        ];
      }
      // let result = [];
      // result = res.data.map(e => {
      //   if (e.childList) {
      //     let tempList = e.childList.map(e2 => {
      //       return {
      //         id: e2.campusId,
      //         label: e2.campusName,
      //         children: e2.childs
      //       };
      //     });
      //     return {
      //       id: e.campusId,
      //       label: e.campusName,
      //       children: tempList
      //     };
      //   } else {
      //     return {
      //       id: e.campusId,
      //       label: e.campusName,
      //       children: e.childs
      //     };
      //   }
      // });
      // console.log(result);
      // this.dataList = [
      //   {
      //     id: 0,
      //     label: this.$t('app.selectAll'),
      //     children: result
      //   }
      // ];
    },
    showAgentDepartmentPopover() {
      this.showAgentDropDown = true;
    },
    // TODO：逻辑处理
    hideAgentDepartmentPopover() {
      this.showAgentDropDown = false;
      this.lstUserId = []; //置空一下
      this.lstUserName = "";
      let selectPeopleName = [];
	    let selectPeopleId = [];
      let selectIdArr = this.$refs.subAgentTree.getCheckedKeys();
      let newSelectIdArr = [];
      selectIdArr.map((item, index) => {
        if (item && item !== 0 && item != undefined) {
          newSelectIdArr.push(parseInt(item));
        }
      }) //把全选的节点去掉
      let selectNodeArr = this.$refs.subAgentTree.getCheckedNodes();
      if (selectNodeArr.length > 0) {
        selectNodeArr.map(item => {
          // 此处应该是value
          let arr = item.value.split("_");
          if (arr.length <= 2 && item["title"]) {
            selectPeopleName.push(item["title"]);
          }
        });
        selectIdArr.map(item => {
          let arr = item.split("_");
          if (arr.length <= 2 && arr[1] != 0) {
            selectPeopleId.push(arr[1]);
          }
        });
        this.lstUserName = selectPeopleName.join(",");
        this.lstUserId = selectPeopleId;
        this.$emit("input", this.lstUserId); //必须在前面
        this.$emit("select", this.lstUserId);
        this.filterText = "";
      } else {
        this.lstUserName = "";
        this.lstUserId = [];
        this.filterText = "";
        this.$emit("input", ''); //必须在前面
        this.$emit("select", []); //为了清空
      }
    },
    clearSelect() {
      this.$refs.subAgentTree.setCheckedKeys([]);

      let node = this.$refs.subAgentTree.getCheckedNodes();
      console.log(node, 'node')

      // 如果清除不全 直接重开
      if (node.length > 0) {
        this.restart = false
        this.$nextTick(() => {
        this.restart = true
        })
      }
      this.$emit('change-tree', {
        value:''
      });
      this.hideAgentDepartmentPopover()
      this.lstUserName = "";
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style lang="scss" scoped>
.is-reverse {
  transform: rotate(-180deg);
}

.selectClass {
  width: 100%;

  :deep(.el-input__inner) {
    height: 32px;
  }
}

:deep(.el-popover) {
  width: 100%;
}

.scrollbar-wrapper {
  background-color: #ffffff;
  max-height: 250px;
  overflow: auto;
  padding-right: 10px;
  margin-bottom: 10px;
  // .el-scrollbar__wrap {
  //   margin-bottom: -30px !important;
  // }
}
</style>

<style lang="scss">
.agent-popover {
  // max-height: 300px;
  // width: 11% !important;
  overflow-y: auto;
  transition: all .3s ease-out;
  .el-tree-node__label {
    font-size: 14px;
    overflow-y: auto;
  }
  &:has(.is-expanded) {
    width: auto !important;

    .el-tree-node__content {
      transition: all 0 ease-out;
    }
  }
}
// 单选不显示父节点复选框
.radio-tree{
  .el-tree-node .is-leaf + .el-checkbox .el-checkbox__inner{display: inline-block;}
  .el-tree-node .el-checkbox .el-checkbox__inner{display: none;}
}
</style>
